import { render } from "./TeachingMaterialList.vue?vue&type=template&id=cf97e2ae&scoped=true"
import script from "./TeachingMaterialList.vue?vue&type=script&lang=js"
export * from "./TeachingMaterialList.vue?vue&type=script&lang=js"

import "./TeachingMaterialList.vue?vue&type=style&index=0&id=cf97e2ae&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-cf97e2ae"

export default script